const utilityAPIBaseUrl = process.env.REACT_APP_AUTH_URL;

export const urls = {
  verifyToken:() => `${utilityAPIBaseUrl}/captcha`
};